<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">企业名称:</span>

                        <el-select
                            v-model="search_data.top_store_code"
                            placeholder="请选择企业名称"
                            @visible-change="getStoreFirst"
                            @change="qiyeChange"
                            clearable
                            @keyup.enter.native="searchStoreClientLists"
                            style="width: 300px"
                        >
                            <el-option
                                v-for="item in options_qiye_code"
                                :key="item.top_store_code"
                                :label="item.name"
                                :value="item.top_store_code"
                            >
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">手机号:</span>

                         <el-input
                            clearable
                            v-model="search_data.consumer_phone"
                            placeholder="请输入订单号"
                            class="handle-input mr10 order-num"
                            @keyup.enter.native="searchStoreClientLists"
                        ></el-input>
                    </el-col>
                    
                </el-row>
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">门店名称:</span>

                        <el-select
                            v-model="search_data.store_code"
                            placeholder="请选择门店名称"
                            @visible-change="getStoreSecond"
                            @change="mendianChange"
                            clearable
                            @keyup.enter.native="searchStoreClientLists"
                            style="width: 300px"
                        >
                            <el-option
                                v-for="item in options_mendian_code"
                                :key="item.store_code"
                                :label="item.name"
                                :value="item.store_code"
                            >
                            </el-option>
                        </el-select>
                    </el-col>
                    
                  
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchStoreClientLists">搜索</el-button>
            <el-button @click="edit_isShow = !edit_isShow">上传</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <!-- <el-table-column label="员工编码" prop="store_admin_code"> </el-table-column> -->

            <!-- <el-table-column label="店铺编码" prop="store_code"> </el-table-column> -->

            <el-table-column label="客户手机号" prop="phone"> </el-table-column>
            <el-table-column label="客户名称" prop="name"> </el-table-column>
            <el-table-column label="车牌号" prop="plate"> </el-table-column>
            <el-table-column label="权益次数" prop="equity_num"> </el-table-column>
            <el-table-column label="公司名称" prop="top_store_name"> </el-table-column>
            <el-table-column label="店铺名称" prop="store_name"> </el-table-column>
            <el-table-column label="权益类型" prop="equity_type_name"> </el-table-column>
            <el-table-column label="店铺员工名称" prop="store_admin_name"> </el-table-column>
            <!-- <el-table-column label="时间" prop="time.YmdHis"> </el-table-column> -->
            <!-- <el-table-column label="城市" prop="city.name"> </el-table-column> -->
            <!-- <el-table-column label="公司编码" prop="main_store_code"> </el-table-column> -->
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
         <!-- 发放组件 -->
        <importClientLists :isShow="edit_isShow" @onSubmit="searchStoreClientLists"></importClientLists>
    </div>
</template>

<script>
var _this;
import importClientLists from './importClientLists.vue';

export default {
    components: {
    
        importClientLists
      
    },
    data() {
        return {
            edit_isShow: false,
            options_mendian_code: [],
            options_qiye_code: [],

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                store_code: '',
                top_store_code: '',
                consumer_phone: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.storeClientLists();
    },

    methods: {
     
      
        mendianChange(val) {
            _this.search_data.store_code = val;
        },
        getStoreSecond(val) {
            if (val) {
                if (_this.search_data.top_store_code == '') {
                    this.$message.error('请先选择企业');
                } else {
                    _this
                        .$post('/store/getStoreSecond', { top_store_code: _this.search_data.top_store_code })
                        .then((res) => {
                            _this.options_mendian_code = res.data;
                        })
                        .catch((err) => {});
                }
            }
        },

        qiyeChange(val) {
            _this.options_mendian_code = []; //选择企业，门店下拉列表绑定值要清空
            _this.search_data.store_code = ''; //选择企业，门店编码
            _this.search_data.top_store_code = val; //企业下拉列表绑定值，根据该值去获取对应企业下所属门店
        },
        getStoreFirst() {
            if (_this.options_qiye_code.length == 0) {
                _this
                    .$post('/store/getStoreFirst')
                    .then((res) => {
                        _this.options_qiye_code = res.data;
                    })
                    .catch((err) => {});
            }
        },

    

        searchStoreClientLists() {
            _this.search_data.page = 1;
            _this.storeClientLists();
        },

        // 搜索用户管理列表
        storeClientLists() {
            _this
                .$post('/store/storeClientLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.storeClientLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
